import React, { Component } from 'react';
import { FormGroup, Col, Radio, ControlLabel } from 'react-bootstrap';
import './styles.scss';
export default class BrokerBusinessType extends Component {
  render() {
    const { input, options } = this.props;
    const radioOptions = options.map((option) => ({
      name: option.label,
      value: option.value,
    }));

    return (
      <FormGroup className={'broker-business-type'}>
        <Col sm={3}>
          <ControlLabel>Business Type:</ControlLabel>
        </Col>
        <Col sm={9}>
          {radioOptions.map((option, key) => {
            return (
              <Radio
                {...input}
                key={key}
                name="radioGroup"
                className="form-radio"
                value={option.value}
                checked={input.value.toString() === option.value.toString()}
                inline
              >
                <span className={'option-label'}> {option.name}</span>
              </Radio>
            );
          })}
        </Col>
      </FormGroup>
    );
  }
}
